import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { ApolloModule } from 'apollo-angular';
import { FcOutlinedSelectModule } from '../../base/fc-outlined-select/fc-outlined-select.module';
import { FcSegmentOutlinedSelectComponent } from './fc-segment-outlined-select.component';

@NgModule({
  declarations: [
    FcSegmentOutlinedSelectComponent
  ],
  imports: [
    CommonModule,
    FuseSharedModule,
    FcOutlinedSelectModule,
    ApolloModule
  ],
  providers: [],
  exports: [
    FcSegmentOutlinedSelectComponent
  ]
})
export class FcSegmentOutlinedSelectModule { }
